import type { ComponentType } from 'react';
import GallectionsSection from './GallectionsSection';
import GallectionsSectionContainer, {
  OwnProps,
} from './GallectionsSection.container';

export default GallectionsSectionContainer(
  GallectionsSection
) as ComponentType<OwnProps>;
